const remoteResource = 'cashflow/api/v1/cash-event-fields';
import Axios from 'axios'

const store = {
    namespaced: true,
    state: {
        fields: ["source", "type", "status"],
        fieldValues: {}
    },
    getters: {
        fieldValues: (state) => (field) => state.fieldValues[field]
    },
    mutations: {
        setFieldValues(state, {field, values}) {
            state.fieldValues[field] = values;
        }
    },
    actions: {
        loadFieldValues({commit, dispatch}, field) {
            return Axios.get(`${remoteResource}/${field}`)
                .then(res => {
                    commit("setFieldValues", {field, values: res.data});
                })
        },
        refreshAllFields({dispatch, state}) {
            return Promise.all(state.fields.map(field => dispatch("loadFieldValues", field)));
        }
    }
};

export default store;